import React, { useEffect, useState } from 'react';
import { 
  ArrowRight, PlusCircle, MinusCircle, Download, Landmark, Wallet, Percent, User, FileText, ChevronRight,
  PiggyBank,
  BriefcaseBusiness,
  BadgeDollarSign,
  Upload,
  DownloadCloud,
  Coins,
  HandCoins,
  Copy,
  Sunrise, Sun, Sunset, 
  Building2
} from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { useNavigate } from "react-router-dom";
import WalletIcon from '../../Assets/wallet.svg'
import { CalendarDays, X, Loader2 } from "lucide-react";
import styles from './Dashboard2.module.css';
import { SiKucoin } from 'react-icons/si';
import Sidebar2 from '../../Components/SideBar2/SideBar2';
import Header2 from '../../Components/Header2/Header2';
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';

// Sample mock tracking dataset for the Recharts metric view
const savingsData = [
  { name: 'Jan', amount: 80 },
  { name: 'Feb', amount: 120 },
  { name: 'Mar', amount: 160 },
  { name: 'Apr', amount: 180 },
  { name: 'May', amount: 200 },
  { name: 'Jun', amount: 230 },
  { name: 'Jul', amount: 250 },
];



export default function Dashboard2() {
  const memberName = localStorage.getItem("memberName");
  const memberNumber = localStorage.getItem("memberNumber");
  const companyName = localStorage.getItem("companyName");
  const [memberData, setMemberData] = useState({});
const [loading, setLoading] = useState(false);
const [error, setError] = useState("");
const [dashboardData, setDashboardData] = useState({});
const [dashboardLoading, setDashboardLoading] = useState(false);
const [selectedDate, setSelectedDate] = useState("");
  const walletBalance = localStorage.getItem("walletBalance");
const getGreeting = () => {
  const hour = new Date().getHours();

  // 12:00 AM - 11:59 AM
  if (hour >= 0 && hour < 12) {
    return {
      text: "Good morning,",
      icon: <Sunrise size={24} color="#f59e0b" />,
    };
  }

  // 12:00 PM - 3:59 PM
  if (hour >= 12 && hour < 16) {
    return {
      text: "Good afternoon,",
      icon: <Sun size={24} color="#facc15" />,
    };
  }

  // 4:00 PM - 11:59 PM
  return {
    text: "Good evening,",
    icon: <Sunset size={24} color="#fb923c" />,
  };
};

const greeting = getGreeting();
  const formatMemberName = (name) => {
  if (!name) return "";
  
  // 1. Convert to Title Case (e.g., "CHAT GPT AI" -> "Chat Gpt Ai")
  const titleCased = name
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // 2. Truncate if over 100 characters
  if (titleCased.length > 20) {
    return `${titleCased.slice(0, 20)}...`;
  }
  
  return titleCased;
};
  const navigate = useNavigate();

  const fetchMemberProfile = async () => {
  setLoading(true);

  try {
    const token = localStorage.getItem("token");
    const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");

    const response = await axios.get(
      `${BASE_URL}/member-auth/my_profile?company_id=${compid}&member_id=${memberid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    setMemberData(response.data.data);
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.message || "Unable to fetch profile.");
  } finally {
    setLoading(false);
  }
};



const fetchDashboardMetrics = async (date = "") => {
  try {
    setDashboardLoading(true);

    const token = localStorage.getItem("token");
    const companyId = localStorage.getItem("companyId");
    const memberId = localStorage.getItem("memberId");

    const params = {
      company_id: companyId,
      member_id: memberId,
    };

    if (date) {
      params.date = date;
    }

    const response = await axios.get(
      `${BASE_URL}/member-auth/dashboard_metrics`,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    setDashboardData(response.data.data);

  } catch (err) {
    console.log(err);
  } finally {
    setDashboardLoading(false);
  }
};

useEffect(() => {
  fetchMemberProfile();
    fetchDashboardMetrics();
}, []);

const handleDateChange = (e) => {
  const date = e.target.value;

  setSelectedDate(date);

  fetchDashboardMetrics(date);
};

const clearDateFilter = () => {
  setSelectedDate("");

  fetchDashboardMetrics();
};

const formatCurrency = (amount) => {

  
  const num = Number(amount);
  if (isNaN(num)) return "0.00";

  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1
  });

  return formatter.format(num);
};

// 1. Map monthly data so that XAxis "name" works correctly
// 2. We use .substring(0, 3) to abbreviate (e.g., "January" -> "Jan") so labels don't overlap
const savingsData = dashboardData?.savings_by_month?.map(item => ({
  name: item.month.substring(0, 3), 
  amount: item.amount
})) || [];

// Optional: Professional tick formatter for the Y-Axis to handle huge ranges (₦0 to ₦19.9M)
const formatYAxis = (value) => {
  if (value >= 1000000) return `₦${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `₦${(value / 1000).toFixed(0)}k`;
  return `₦${value}`;
};

// Optional: Tooltip formatter to show the full nicely-formatted Naira amount when hovered
const formatTooltip = (value) => {
  return new Intl.NumberFormat('en-NG', { 
    style: 'currency', 
    currency: 'NGN', 
    maximumFractionDigits: 0 
  }).format(value);
};

const StatLoader = () => (
  <div className={styles.statLoader}>
    <Loader2 size={18} className={styles.loaderSpin} />
  </div>
);

  return (
    <div className={styles.container}>
      {/* 1. APP SIDEBAR INTERFACE BAR LAYER */}
      <Sidebar2 />

      {/* 2. WORKING PRIMARY VIEWPORT FRAMEWORK WRAPPER */}
      <main className={styles.mainContent}>
        {/* APP UPPER RESPONSIVE NAVIGATION BAR HEADER */}
        <Header2 />

        {/* COMPONENT CENTRAL WORKSPACE DASHBOARD BLOCKS */}
        <div className={styles.workspace}>
          
          {/* WELCOME BANNER PANEL */}
          <div className={styles.welcomeContainer}>

          <div className={styles.welcomeBanner}>
            {/* The main wrapper splits into: Hand on the left, Text stack on the right */}
            <div className={styles.welcomeContent}>
              
              {/* Left Side: Waving Hand */}
              <span className={styles.wavingHand}>👋</span>
              
              {/* Right Side: Closely packed text column */}
              <div className={styles.textStack}>
  <div className={styles.greetingRow}>
    {/* {greeting.icon} */}
    <h3 className={styles.welcomeText}>
      {greeting.text}
    </h3>
  </div>

  <h2 className={styles.memberName}>
    {formatMemberName(memberName)}
  </h2>

  <div className={styles.membershipBadge}>
  <div className={styles.membershipContent}>
    <Building2 className={styles.buildingIcon} size={16} />
    <p className={styles.membershipNo} title={`Business Performance Overview for ${companyName}`}>
      
      <strong className={styles.companyNameHighlight}>
        {companyName.length > 30 ? `${companyName.slice(0, 30)}...` : companyName}
      </strong>
    </p>
  </div>
</div>
</div>

  </div>
</div>
       <div className={styles.welcomeBanner2}>
  {/* Left Section: Vertically Stacked Wallet Info */}
  <div className={styles.walletInfo}>
    <h3 className={styles.walletNumber}>Available Balance</h3>
    
    <div className={styles.walletValueRow}>
      <Wallet className={styles.walletIcon} size={24} />
      <h2 className={styles.walletValue}>
        ₦{parseFloat(walletBalance).toLocaleString('en-US', {
          minimumIntegerDigits: 1,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </h2>
    </div>
    
    <p className={styles.walletBalanceLabel}>Available for transactions.</p>
  </div>
  
  {/* CENTER GOLDEN SMART CHIP */}
  <div className={styles.atmChipContainer}>
    <img src={WalletIcon} alt="wallet" style={{
      width: 50, height: 50, objectFit: 'contain',
      opacity: 0.5
    }} />
  </div>
  
  {/* Right Section: Action Button */}
  <div className={styles.fundContainer}>
    <span className={styles.walletBalanceLabel} style={{  fontSize: 15 }}>000-0000-000</span>
    <button className={styles.fundButton}>
      + Fund Wallet
    </button>
  </div>
</div>
         
          </div>

          {/* <div className={styles.dashboardFilter}>

    <div className={styles.dateFilter}>

        <CalendarDays size={18} color="#16a34a" />

        <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            className={styles.dateInput}
        />

        {selectedDate && (
            <button
                className={styles.clearDateBtn}
                onClick={clearDateFilter}
            >
                <X size={16} />
            </button>
        )}

    </div>

</div> */}

          {/* METRIC HIGHLIGHTS METRICS CARDS GRID GRID */}
          <div className={styles.metricGrid}>
            <div className={styles.metricCard}>
              <div>
                <div className={`${styles.iconWrapper} ${styles.greenIcon}`}><Wallet size={18} /></div>
                <p className={styles.metricLabel}>Total Savings</p>
                <h4 className={styles.metricValue}> {dashboardLoading ? (
    <StatLoader />
  ) : (
    `₦${formatCurrency(dashboardData.total_savings)}`
  )}</h4>
              </div>
              {/* <button className={styles.viewDetailsBtn}>
                <span>View Details</span> <ArrowRight size={12} />
              </button> */}
            </div>
            
            <div className={styles.metricCard}>
              <div>
                <div className={`${styles.iconWrapper} ${styles.blueIcon}`}><PiggyBank size={18} /></div>
                <p className={styles.metricLabel}>Savings This Month</p>
                <h4 className={styles.metricValue}> {dashboardLoading ? (
    <StatLoader />
  ) : (
    `₦${formatCurrency(dashboardData.savings_this_month)}`
  )}</h4>
              </div>
              {/* <button className={styles.viewDetailsBtn}>
                <span>View Details</span> <ArrowRight size={12} />
              </button> */}
            </div>

            <div className={styles.metricCard}>
              <div>
                <div className={`${styles.iconWrapper} ${styles.purpleIcon}`}><BriefcaseBusiness size={18} /></div>
                <p className={styles.metricLabel}>Active Loans</p>
                <h4 className={styles.metricValue}>{dashboardLoading ? (
    <StatLoader />
  ) : (
    dashboardData.active_loans || 0
  )}</h4>
              </div>
              {/* <button className={styles.viewDetailsBtn}>
                <span>View Details</span> <ArrowRight size={12} />
              </button> */}
            </div>

            <div className={styles.metricCard}>
              <div>
                <div className={`${styles.iconWrapper} ${styles.orangeIcon}`}><BadgeDollarSign size={18} /></div>
                <p className={styles.metricLabel}>Loan Balance</p>
                <h4 className={styles.metricValue}>{dashboardLoading ? (
    <StatLoader />
  ) : (
    `₦${formatCurrency(dashboardData.loan_balance)}`
  )}</h4>
              </div>
              {/* <button className={styles.viewDetailsBtn}>
                <span>View Details</span> <ArrowRight size={12} />
              </button> */}
            </div>

            <div className={styles.metricCard}>
              <div>
                <div className={`${styles.iconWrapper} ${styles.amberIcon}`}><Percent size={18} /></div>
                <p className={styles.metricLabel}>Dividends Earned</p>
                <h4 className={styles.metricValue}>₦0.00</h4>
              </div>
              {/* <button className={styles.viewDetailsBtn}>
                <span>View Details</span> <ArrowRight size={12} />
              </button> */}
            </div>
          </div>

          {/* PERFORMANCE LINE GRAPH AND FINANCIAL LOAN SUMMARY ROW */}
        <div className={styles.twoColGrid}>
  <div className={styles.card}>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
      <h3 className={styles.cardTitle}>Savings Growth <span>(Monthly)</span></h3>
    </div>
    
    <div style={{ height: 192, width: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart 
          data={savingsData} 
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }} // Adjusted left margin to accommodate NGN symbols
        >
          <defs>
            <linearGradient id="colorSavingsScoping" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#15803d" stopOpacity={0.15}/>
              <stop offset="95%" stopColor="#15803d" stopOpacity={0.0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
          <XAxis 
            dataKey="name" 
            tick={{ fontSize: 10, fill: '#94a3b8' }} 
            axisLine={false} 
            tickLine={false} 
          />
          <YAxis 
            tick={{ fontSize: 10, fill: '#94a3b8' }} 
            axisLine={false} 
            tickLine={false} 
            tickFormatter={formatYAxis} // Replaced unit="k" with dynamic formatter
          />
          <Tooltip formatter={formatTooltip} />
          <Area 
            type="monotone" 
            dataKey="amount" 
            stroke="#15803d" 
            strokeWidth={2} 
            fillOpacity={1} 
            fill="url(#colorSavingsScoping)" 
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>

  <div className={styles.card} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <div>
      <div className={styles.loanHeader}>
        <FileText size={18} style={{ color: '#15803d' }} />
        <h3 className={styles.loanTitle}>Loan Summary</h3>
      </div>
      <div className={styles.loanList}>
        <div className={styles.loanRow}><span className={styles.loanLabel}>Approved Amount</span><span className={styles.loanValue}>₦0.00</span></div>
        <div className={styles.loanRow}><span className={styles.loanLabel}>Outstanding Balance</span><span className={styles.loanValue}>₦0.00</span></div>
        <div className={styles.loanRow}><span className={styles.loanLabel}>Next Payment</span><span className={styles.loanValue}>₦0.00</span></div>
        <div className={styles.loanRow}><span className={styles.loanLabel}>Due Date</span><span className={styles.loanValue}>-</span></div>
      </div>
    </div>
    <button className={styles.loanFooter}>
      <span>View Loan Schedule</span> <ArrowRight size={12} />
    </button>
  </div>
</div>

          {/* DEDUCTIONS LOG TABLE AND RECENT TRANSACTIONS CONTAINER ROW */}
          <div className={styles.equalGrid}>
            <div className={styles.card}>
              <div className={styles.sectionHeader}>
                <h3 className={styles.cardTitle}>Recent Transactions</h3>
                <a href="/" className={styles.viewAll}>View All</a>
              </div>
              <div className={styles.listItems}>
                <div className={`${styles.itemRow} ${styles.itemRowHover}`}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#16a34a', color: '#f0fdf4' }}><DownloadCloud size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Savings Deposit</p>
                      <p className={styles.itemDate}>01 Jul 2024, 10:30 AM</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.positive}`}>+₦50,000</span>
                </div>
                <div className={`${styles.itemRow} ${styles.itemRowHover}`}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#2563eb', color: '#eff6ff' }}><Upload size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Loan Repayment</p>
                      <p className={styles.itemDate}>28 Jun 2024, 02:15 PM</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.negative}`}>-₦75,000</span>
                </div>
                <div className={`${styles.itemRow} ${styles.itemRowHover}`}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#7c3aed', color: '#faf5ff' }}><Percent size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Dividend Payment</p>
                      <p className={styles.itemDate}>20 Jun 2024, 11:45 AM</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.positive}`}>+₦45,000</span>
                </div>
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.sectionHeader}>
                <h3 className={styles.cardTitle}>Upcoming Deductions</h3>
                <a href="#" className={styles.viewAll}>View All</a>
              </div>
              <div className={styles.listItems}>
                <div className={styles.itemRow}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#16a34a', color: '#f0fdf4' }}><PiggyBank size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Monthly Savings</p>
                      <p className={styles.itemDate}>25 Jul 2024</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.neutral}`}>₦25,000</span>
                </div>
                <div className={styles.itemRow}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#2563eb', color: '#eff6ff' }}><Landmark size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Loan Repayment</p>
                      <p className={styles.itemDate}>25 Jul 2024</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.neutral}`}>₦75,000</span>
                </div>
                <div className={styles.itemRow}>
                  <div className={styles.itemMeta}>
                    <div className={styles.itemIcon} style={{ backgroundColor: '#7c3aed', color: '#faf5ff' }}><HandCoins size={16} /></div>
                    <div>
                      <p className={styles.itemName}>Welfare</p>
                      <p className={styles.itemDate}>25 Jul 2024</p>
                    </div>
                  </div>
                  <span className={`${styles.amount} ${styles.neutral}`}>₦5,000</span>
                </div>
              </div>
            </div>
          </div>

          {/* CORE QUICK UTILITIES, PROGRESS METERS, AND DETAILS PROFILE DATA GRID */}
          <div className={styles.threeColGrid}>
            <div className={styles.card} style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <h3 className={styles.cardTitle} style={{ marginBottom: '0.5rem' }}>Quick Actions</h3>
              <button className={styles.actionButton} onClick={() => navigate('/loans/loan-application')}>
                <span className={styles.actionLeft}><Landmark size={14} /> <span>Apply for Loan</span></span>
                <ChevronRight size={14} style={{ color: '#94a3b8' }} />
              </button>
              <button className={styles.actionButton} onClick={() => navigate('/savings/overview')}>
                <span className={styles.actionLeft}><PlusCircle size={14} /> <span>Savings Overview</span></span>
                <ChevronRight size={14} style={{ color: '#94a3b8' }} />
              </button>
              <button className={styles.actionButton} onClick={() => navigate('/savings/withdrawal-request')}>
                <span className={styles.actionLeft}><MinusCircle size={14} /> <span>Withdrawal Request</span></span>
                <ChevronRight size={14} style={{ color: '#94a3b8' }} />
              </button>
              <button className={styles.actionButton}>
                <span className={styles.actionLeft}><Download size={14} /> <span>Download Statement</span></span>
                <ChevronRight size={14} style={{ color: '#94a3b8' }} />
              </button>
            </div>

            <div className={styles.card} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div className={styles.eligibilityHeader}>
                <h3 className={styles.cardTitle}>Loan Eligibility</h3>
                {/* <p style={{ marginTop: '0.5rem' }}>Eligible Amount</p>
                <h2>₦2,500,000</h2> */}
              </div>
              <div className={styles.dialSection}>
                <div className={styles.radialDial}>
                  <span className={styles.dialText}>100%</span>
                </div>
                <div className={styles.scoreInfo}>
                  <p className={styles.scoreTitle}>Excellent Credit Score</p>
                  <p className={styles.scoreDesc}>Based on consistency & history</p>
                </div>
              </div>
              {/* <button className={styles.greenLinkButton}>
                <span>Check Eligibility</span> <ArrowRight size={12} />
              </button> */}
            </div>

            <div className={styles.card} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <h3 className={styles.cardTitle} style={{ marginBottom: '1rem' }}>Member Information</h3>
                <div className={styles.infoRows}>
  

  <div className={styles.infoLine}>
    <span className={styles.infoLabel}>Employment Status</span>
    <span className={styles.infoValue}>
      {memberData?.employer_name?.trim() ? "Employed" : "Unemployed"}
    </span>
  </div>

  <div className={styles.infoLine}>
    <span className={styles.infoLabel}>Membership Date</span>
    <span className={styles.infoValue}>
      {memberData?.created_at ? new Date(memberData.created_at).toLocaleDateString() : "-"}
    </span>
  </div>

  <div className={styles.infoLine}>
    <span className={styles.infoLabel}>Next AGM</span>
    <span className={styles.infoValue}>
      {memberData?.next_agm || "Not Set"}
    </span>
  </div>
  <div className={styles.infoLine}>
    <span className={styles.infoLabel}>Branch</span>
    <span className={styles.infoValue}>
      {memberData?.branch_name || "-"}
    </span>
  </div>
</div>
              </div>
              <button className={styles.greenLinkButton} style={{ marginTop: '1rem' }} onClick={() => navigate('/profile')}>
                <span>View Full Profile</span> <ArrowRight size={12} />
              </button>
            </div>
          </div>

          {/* BOARD BROADCAST ANNOUNCEMENTS SECTION */}
          {/* <div className={styles.card}>
            <div className={styles.sectionHeader}>
              <h3 className={styles.cardTitle}>Notices & Announcements</h3>
              <a href="#" className={styles.viewAll}>View All</a>
            </div>
            <div className={styles.announcementsList}>
              <div className={styles.announcementItem}>
                <div className={styles.announcementLeft}>
                  <div className={`${styles.dot} ${styles.blueDot}`}></div>
                  <div className={styles.announcementContent}>
                    <h4>AGM Scheduled for August 20</h4>
                    <p>All members are by this notice informed that our Annual General Meeting holds on August 20, 2024.</p>
                  </div>
                </div>
                <span className={styles.announcementDate}>10 Jul 2024</span>
              </div>
              
              <div className={styles.announcementItem}>
                <div className={styles.announcementLeft}>
                  <div className={`${styles.dot} ${styles.purpleDot}`}></div>
                  <div className={styles.announcementContent}>
                    <h4>New Housing Loan Product Available</h4>
                    <p>We are pleased to announce our new housing loan product with low interest rates.</p>
                  </div>
                </div>
                <span className={styles.announcementDate}>08 Jul 2024</span>
              </div>
            </div>
          </div> */}

        </div>
      </main>
    </div>
  );
}